export function analysisSieves (analysis = {}) {
  if (analysis.zarandas?.length) return analysis.zarandas.map(item => ({ ...item }))
  return [{ zaranda: analysis.zaranda ?? null, caida: analysis.caidaZaranda ?? null }]
}

export function sieveFall (zarandas = []) {
  return Number(zarandas.reduce((total, item) => total + Number(item.caida || 0), 0).toFixed(4))
}
